<template>
  <v-app id="inspire" class="app_principal">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex lg10>
            <v-card class="elevation-20 d-flex align-center" :min-height="$vuetify.breakpoint.xs?'550':'450'">
              <v-card-text>
                <v-layout row wrap align-center justify-center>
                   <v-flex lg5 md5 sm6 xs12>
                      <v-img
                      :src="require('@/assets/logo-vertical-minjus-2021.png')"
                      lazy
                      :aspect-ratio="$vuetify.breakpoint.xs?'2':$vuetify.breakpoint.lg?'1.7':'2'"
                      contain
                    ></v-img>
                  </v-flex>
                  <v-flex lg4 md4 sm4 xs8 offset-lg1 offset-md1 offset-xs1>
                    <h2 class="mb-4">INICIO DE SESIÓN</h2>
                    <router-view></router-view>
                    <v-snackbar v-model="snackbar" multi-line right top color="error">{{ error }}</v-snackbar>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <div class="help">
              <h3>
                <span>Si tiene dudas o consultas</span>
              </h3>
              <p>
                <span>Contáctese con nosotros:</span>
              </p>
              <p>
                <span>
                  <strong>Ministerio de Justicia y Transparencia Institucional</strong>
                  <v-icon>call</v-icon>(591-2) 2158900 - 2158901 -2158902 - 2313838
                </span>
              </p>
              <p>
                <span>
                  <strong>Área Tecnologias Informacion Comunicación:</strong>
                  <v-icon>call</v-icon>Interno. 1801
                </span>
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
     <v-overlay :value="loading_app">
      <v-progress-circular indeterminate size="64" class="mb-5"></v-progress-circular> <br/>{{mensaje_app}}
    </v-overlay>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data: () => ({
    snackbar: false,
    isLoading: false,
    fullPage: true
  }),
  computed: {
     ...mapState(["mensaje_app","loading_app"]),
    error() {
      return this.$store.state.error;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.snackbar = true;
      }
    },
    snackbar(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  },
  mounted() {
    this.verificarToken();
  },
  methods: {
    verificarToken() {
      if (this.$store.state.token != null) {
        this.$router.push("/inicio");
        this.$store.commit(
          "setError",
          "Debe cerrar la sesion o cambiar de modulo si lo que desea es salir del sistema"
        );
      }
    }
  }
};
</script>

<style>
#boton_login {
  color: white;
}

.boton_ciudadania {
  background: transparent url(/src/assets/boton_ciudadania_digital.png)
    no-repeat !important;
  background-size: 50%;
}

#inspire.app_principal {
  background-image: url(../assets/background.png);
  background-repeat: repeat;
  background-size: 40% !important;
}

.help {
  text-align: center;
  padding: 30px 10px 20px;
  color: #666666;
}
</style>
